<template>
  <div id="gnb-root" :data-solution="solutionKey">
    <!--    오피스 -->
    <Header v-if="isShowOfficeGnb" :menu-name="menuName" :search-type="searchType" />

    <!--    하이웍스관리 / 영업관리 / 경영 플랫폼 -->
    <VariantHeader v-if="isShowVariantGnb" :serviceName="serviceName" />
  </div>
</template>

<script>
import Header from './Header.vue';

import VariantHeader from './VariantHeader.vue';
import { getSolutionName } from '@/js/getSolutionName';

const mountEl = document.querySelector('#gnb-app');

export default {
  name: 'App',
  components: {
    Header,
    VariantHeader,
  },
  mounted() {
    try {
      //* 검색 타입 설정(오피스 플랫폼에서만 사용 됨) */
      this.searchType = mountEl.attributes['data-search-type'] ? mountEl.attributes['data-search-type'].value : '';
    } catch (e) {
      this.searchType = '';
    }

    try {
      //* 메뉴 설정(오피스 플랫폼에서 사용 됨) */
      this.menuName = mountEl.attributes['data-menu-name'] ? mountEl.attributes['data-menu-name'].value : '';
    } catch (e) {
      this.menuName = '';
    }

    try {
      // office / erp / officeadmin / sales / mailamin
      this.serviceName = mountEl.attributes['data-service-name']
        ? mountEl.attributes['data-service-name'].value
        : 'office';
    } catch (e) {
      this.serviceName = 'office';
    }

    /**
     * 하이웍스 관리(구) 에서 GNB 로드 시, data-service-name 설정이 어려워 GNB 에서 도메인으로 설정되도록 추가
     */
    if (location.href.includes('h_admin') && location.href.includes('office.hiworks.com')) {
      this.serviceName = 'officeadmin';
    }

    this.setSolutionKey();

    console.log('[GNB] service', { service: this.serviceName, searchType: this.searchType, menu: this.menuName });
  },

  computed: {
    isShowOfficeGnb() {
      return this.serviceName === 'office';
    },
    isShowVariantGnb() {
      return (
        this.serviceName === 'erp' ||
        this.serviceName === 'officeadmin' ||
        this.serviceName === 'sales' ||
        this.serviceName === 'mailadmin' ||
        this.serviceName === 'mail-archiving'
      );
    },
  },
  methods: {
    setSolutionKey() {
      // menuName 에 따라 설정해주기
      this.solutionKey = getSolutionName(this.menuName, window.location.pathname);
    },
  },
  data() {
    return {
      searchType: '',
      menuName: '',
      serviceName: 'office',
      // 기본적으로 TabMenu 에서 솔루션을 식별하기 위한 키 값
      solutionKey: '',
    };
  },
};
</script>
